import "unpoly/unpoly.js"
import "unpoly/unpoly.css"

import Helpers from "@/unpoly/helpers"

import UnpolyBootstrap from "@/unpoly/bootstrap"
import UnpolyReact from "@/unpoly/react"
import UnpolyPasswordToggle from "@/unpoly/passwordToggle"

const start = () => {
  Helpers.withUnpoly((up) => {
    up.log.config.banner = false
    up.fragment.config.runScripts = true

    UnpolyBootstrap.start({ up, modalSelector: ".global-modal-holder" })
    UnpolyReact.start({ up })
    UnpolyPasswordToggle.start()

    /**
     *  Booting is disabled through the following line in our main layout
     *    = javascript_pack_tag 'unpoly_application', "up-boot" => "manual"
     *
     *  Seeing
     *    Call up.boot() after you have configured Unpoly
     *
     *  is normal.
     *
     *  Unpoly *always* prints this out when manual boot is in effect.
     */
    // FIXME Need to call after loaded only!! document.addEventListener('DOMContentLoaded', () => up.boot())
    up.boot()
  })
}

export default { start }
